import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { AgentSerpStore } from 'common/module/agent-serp/store';
import { AgentTabPaginationViewStore } from 'desktop/module/agent/tab/pagination/view-store';

export function AgentTabPaginationViewStoreFactory(agentSerpStore: AgentSerpStore): AgentTabPaginationViewStore {
  return new AgentTabPaginationViewStore(EventEmitterFactory(), WindowLocationService(), agentSerpStore);
}
